import React, { useState} from 'react'

import {
  GlobalContainer,
  ContentContainer,
  ContentContainer11,
  ContentContainer3,
  ContentContainer4,
  ContentContainerTable,
  ContentContainerDown,
  Title,
  Text,
  TitleContainer,
  ContentContainerButtons,
} from './styles'

import ModalSuccess from '../../Components/Messages/Success/index'
import MessageError from '../../Components/Messages/Error'
import ModalConfirm from '../../Components/Modal/Confirm'

export default function UnitManagerScheduleCurrentDetailsManagement(props) {
  const [isModalConfirmVisible, setModalConfirmVisible] = useState(false)

  return (
    <>
      {!props.loadOperator ? (
        <div style={{ marginTop: '75px' }}>
          <h1> Error on the page! </h1>
        </div>
      ) : (
        <>
            <ModalConfirm
              id='modalconfirmlert'
              appear={isModalConfirmVisible}
              title='Confirmar a volta para o horário normal?'
              text='Tem certeza que deseja voltar para o horário normal?'
              textButton1='Cancelar'
              actionButton1={() => setModalConfirmVisible(false)}
              textButton2='Sim'
              actionButton2={(e) => {
                props.buttonUndoException(props.unit.unidade.value)
                setModalConfirmVisible(false)
              }}
              textButton3='Sim'
            />
          <GlobalContainer>
            {props.fromSuccessMsg && <ModalSuccess text={props.fromSuccessMsg} />}
            {props.erroMsg?.length > 0 && <MessageError show={true} text={props.erroMsg} />}

            <ContentContainer4>
              <TitleContainer>
                <Title> {props.pageTitle} </Title>
              </TitleContainer>
            </ContentContainer4>
            <ContentContainer4>
                <p style={{ fontWeight: 'bold', textAlign: 'justify' }}>{props.pageGuidance2}</p>
                <p style={{ fontWeight: 'bold', textAlign: 'justify' }}>{props.pageGuidance}</p>
            </ContentContainer4>
            <ContentContainer>
              <ContentContainer4>
                <ContentContainer11>
                  <label> Nome da Unidade </label>
                  <Text>{props.unit.name}</Text>
                </ContentContainer11>
              </ContentContainer4>
            </ContentContainer>

            <ContentContainer4>
              <ContentContainer11>
                <label>Horário(s) da rede de atendimento (Horário de Brasília):</label>
                <Text>
                  {props.orgaoScheduleList.map((schedule) => (
                    <div>{schedule.DIAS_SEMANA}, {schedule.HORA_INICIO} às {schedule.HORA_FIM}</div>
                  ))}
                </Text>
              </ContentContainer11>
            </ContentContainer4>

            <ContentContainer3>
              <ContentContainerTable>
                <div className='br-table' data-search='data-search' data-selection='data-selection'>
                  <table>
                    <thead>
                      <tr>
                        <th scope='col0' style={{ color: '#1351B4' }}></th>
                        <th scope='col2' style={{ color: '#1351B4' }}>
                          Dias da semana
                        </th>
                        <th scope='col3' style={{ color: '#1351B4' }}>
                          Horário Inicial
                        </th>
                        <th scope='col3' style={{ color: '#1351B4' }}>
                          Horário Final
                        </th>
                        <th scope='col4' style={{ color: '#1351B4' }}>
                          Data limite
                        </th>
                        <th scope='col99' style={{ color: '#1351B4' }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td> </td>
                        <td>
                            <select value={props.unit.dias_semana} onChange={(e) => props.setUnit({ ...props.unit, dias_semana: e.target.value })}>
                              {props.days.map((d) => (
                                <option key={d.value} value={d.value}>
                                  {d.label}
                                </option>
                              ))}
                            </select>
                        </td>
                        <td>
                            <input
                              type='time'
                              value={props.unit.hora_inicio}
                              onChange={(e) => props.setUnit({ ...props.unit, hora_inicio: e.target.value })}
                            />
                        </td>
                        <td>
                            <input
                              type='time'
                              value={props.unit.hora_fim}
                              onChange={(e) => props.setUnit({ ...props.unit, hora_fim: e.target.value })}
                            />
                        </td>
                        <td>
                            <input
                              type='date'
                              value={props.unit.data_limite}
                              onChange={(e) => props.setUnit({ ...props.unit, data_limite: e.target.value })}
                            />
                        </td>
                        <td> </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ContentContainerTable>
            </ContentContainer3>

            <ContentContainer>
              <ContentContainer4>
                <ContentContainer11>
                  <label> Justificativa </label>
                  <textarea
                      rows='4'
                      value={props.unit.motivo}
                      onChange={(e) => props.setUnit({ ...props.unit, motivo: e.target.value })}></textarea>                  
                </ContentContainer11>
              </ContentContainer4>
            </ContentContainer>

            <ContentContainerDown>
              <ContentContainerButtons>
                <button className='br-button' type='button' onClick={() => props.history.push(props.buttonBackRoute)}>
                  Voltar
                </button>
                <button
                  className={`br-button primary ${props.loadingButton ? ' loading ' : ''} `}
                  type='button'
                  onClick={() => {
                    setModalConfirmVisible(true)
                  }}>
                  Apagar horário de exceção
                </button>
                <button
                  className={`br-button primary ${props.loadingButton ? ' loading ' : ''} `}
                  type='button'
                  onClick={() => {
                    props.confirmUpdate()
                  }}>
                  Confirmar
                </button>
              </ContentContainerButtons>
            </ContentContainerDown>
          </GlobalContainer>
        </>
      )}
    </>
  )
}
